// src/Components/Pages/Branches.jsx
import React from "react";
import BranchManagement from "../AllComponents/BranchManagement";

const Branches = () => {
    return (
        <div className="page-layout">
            <BranchManagement />
        </div>
    );
};

export default Branches;
